import { Box } from '@material-ui/core';
import React from 'react';

import { CustomPaper } from '@/components/shared/components/CustomPaper';

interface FileCardWrapperProps {
  children: React.ReactNode;
}

export const FileCardWrapper = ({ children }: FileCardWrapperProps) => {
  return (
    <CustomPaper fill="paper" style={{ padding: '0 16px', display: 'flex', height: '56px' }}>
      <Box display={'inline-flex'} justifyContent={'space-between'} width={'100%'} alignItems={'center'} gridGap={16}>
        {children}
      </Box>
    </CustomPaper>
  );
};
